//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/mashroom/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/mashroom/partners' // @/configurations/content/partners-dark для темной темы

export default {
  pageTitle: 'Люди в RPA',
  logo: {
    image: require('@/assets/logo/ghost1.png'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  pageBackgroundImage: require('@/assets/background/Vmake-1728655854.png'), // путь до кастомного фона
  aboutActivity: {
    name: 'Люди в RPA',
    description: [
      '<img style="margin-right:20px" src="assets/image-block/gazprom_2.png"</img>   <img style="margin-right:20px" src="assets/image-block/x5_tech.png"</img>',
      '«Люди в роботизации» — это не просто митап, а площадка для обсуждения насущных проблем и возможностей в роботизации процессов. ',
      'Совместное мероприятие, организованное командами X5 Tech и Газпромбанк.Тех, ставит своей целью изменить парадигму конференций по роботизации — отойти от обычного обсуждения преимуществ роботизации перед другими подходами к автоматизации и сосредоточить внимание на тех, кто сегодня задает вектор развития этого бурно развивающегосегося направления.',
      'Целевая аудитория — не финансовые директора корпораций, которых интересуют суммы экономических эффектов и рентабельность инвестиций в технологию, а реальные разработчики RPA, у которых в фокусе внимания актуальные вопросы современного этапа развития технологии:',
      '<uh> <li>Управление командами роботизации — чем отличается организация RPA-разработки от других продуктовых команд;</li> <li>Citizen-разработка — разработка RPA-решений силами линейных сотрудников: коллеги поделятся опытом и успехами такого подхода, обсудят риски и перспективы развития;</li> <li>Развитие отечественных платформ роботизации — представители ведущих платформ поделятся своим видение текущий ситуации и расскажут, как они адаптируют свои решения под требования разработчиков;</li> <li>Квалификационный стандарт RPA — тимлиды RPA вместе обсудят, какими навыками должен обладать сотрудник в начале пути и к каким вершинам должен стремиться в профессиональном росте.</li>',
      'Поднятые темы обширны и обсудить их полностью в рамках одного события маловероятно: наши ожидания состоят в том, что все дискуссии 28 октября станут началом детального обсуждения поднятых вопросов в сообществе, а результаты обсуждений принесут пользу нынешним и будущим разработчикам RPA.',
      '',
      '',
      '',
      '',
      '',
      '',
      ''
    ],
    date: '28.10.2024',
    time: '14:00 - 19:10'
  },
  activities: [
    {
      tabName: 'Выберите', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'KnhoLWdX',
          id: 4922,
          hallName: 'Основной шоурил' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Расписание' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      '',
      '',
      '',
      ''
    ]
  },
  info: {
    title: 'О компаниях', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'Газпромбанк.Тех — это цифровая датацентричная организация, в центре которой человек. Наша команда создает классные клиентоориентированные сервисы, развивает собственную Data Science-экспертизу, внедряет гибкие практики разработки продуктов и инвестирует в инновации.',
      'Х5 Tech — IT-компания и основной цифровой партнер торговых сетей и бизнесов Х5 Group. Более 4 500 специалистов в команде разрабатывают решения, которые помогают сотрудникам группы работать с максимальным технологическим комфортом, а миллионам покупателей — быстро и удобно покупать свежие продукты.',
      ''
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Наши клиенты' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Банк ВТБ,',
    phone: ''
  }
}
